import { getDatabase, ref, set } from "firebase/database";
import { SessionScope } from "globals/enums";
import { handleError } from "./sentry";
import { participantGroupSessionPath } from "./firebase-path";

export const updateIsRefreshedInFirebase = (
  session_id,
  isRefreshed: boolean
): void => {
  const database = getDatabase();
  const path = `session/${session_id}/is_refreshed`;
  const isRefreshedRef = ref(database, path);
  set(isRefreshedRef, isRefreshed).catch((error) => {
    handleError(`Error setting is_refreshed in firebase: ${error}`);
  });
};

export const updateCandidatePrecheckStatus = async (
  session_id: number,
  pre_check_success: boolean,
  session_type: SessionScope,
  participantGroupId?: number
): Promise<void> => {
  try {
    if (
      session_type === SessionScope.LiveProctor &&
      !(typeof participantGroupId === "number" && participantGroupId > 0)
    ) {
      handleError(
        `Error setting pre_check_success in firebase: missing participant_group_id for live proctor session ${session_id}`
      );
      return;
    }
    const database = getDatabase();
    const path =
      session_type === SessionScope.LiveProctor
        ? participantGroupSessionPath(participantGroupId as number, session_id, "pre_check_success")
        : `session_v2/${session_id}/pre_check_success`;
    const sessionRef = ref(database, path);
    await set(sessionRef, pre_check_success);
  } catch (error) {
    handleError(`Error setting pre_check_success in firebase: ${error}`);
  }
};
